module.exports = __webpack_public_path__ + "img/金属材料学3_8.8f09b469.png";